import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ButtonService {
  public isDisabled: BehaviorSubject<any> = new BehaviorSubject<boolean>(false);
  constructor() { }

  onShow(): void {
    this.isDisabled.next(true);
  }
  onHide(): void {
    this.isDisabled.next(false);
  }
}
